import React from 'react';

interface RadioButtonProps {
  name: string;
  value: string;
  checked: boolean;
  label: string;
  labelClassName?: string;
  description?: string; // Optional description prop
  descriptionUnchecked?: string; // Optional description prop
  disabled?: boolean;
  checkable?: boolean; // New prop to determine if radio can be unchecked
  onChange: (value: string) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  value, checked, label, labelClassName, description, descriptionUnchecked, onChange, disabled, checkable = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  if (!checkable) {
    return (
      <div className="flex flex-col">
        <label className={`flex items-center gap-3 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={handleClick}
            className="sr-only"
          />
          <span
            className={`h-4 w-4 rounded-full border-2 flex items-center justify-center ${checked ? 'border-primary-500' : 'border-border-primary'}`}
            aria-hidden="true"
          >
            {checked && (
              <span className="h-2 w-2 rounded-full bg-primary-500" />
            )}
          </span>
          <span className={`text-text-primary ${labelClassName}`}>{label}</span>
        </label>
        {description && checked && <span className="text-text-tertiary text-xs ml-7 mt-0">{description}</span>}
        {descriptionUnchecked && <span className="text-text-tertiary text-xs ml-7 mt-0">{descriptionUnchecked}</span>}
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <label
        className={`flex items-center gap-3 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={handleClick}
      >
        <input
          type="radio"
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={handleClick}
          className="sr-only"
        />
        <span
          className={`h-4 w-4 rounded-full border-2 flex items-center justify-center ${checked ? 'border-primary-500' : 'border-border-primary'}`}
          aria-hidden="true"
        >
          {checked && (
            <span className="h-2 w-2 rounded-full bg-primary-500" />
          )}
        </span>
        <span className={`text-text-primary ${labelClassName}`}>{label}</span>
      </label>
      {description && checked && <span className="text-text-tertiary text-xs ml-7 mt-0">{description}</span>}
      {descriptionUnchecked && <span className="text-text-tertiary text-xs ml-7 mt-0">{descriptionUnchecked}</span>}
    </div>
  );
};

export default RadioButton;
